// extracted by css-extract-rspack-plugin
export default {"field":"PillsInput-module__field___MEeVV"};